import React, { useState, useEffect } from "react";
import ReactExport from "react-export-excel";
import { conf } from "../const";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
/*
const dataSet = [
  {
    name: "Sheet_1",
    columns: [
      { label: "Col 1", value: "col1" },
      { label: "Col 2", value: "col2" },
      { label: "Col 3", value: "col3" },
    ],
    sheet: [
      { col1: "c11", col2: "c12", col3: "c13" },
      { col1: "c21", col2: "c22", col3: "c23" },
      { col1: "c31", col2: "c32", col3: "c33" },
    ],
  },
  {
    name: "Sheet_2",
    columns: [
      { label: "Col 1", value: "col1" },
      { label: "Col 2", value: "col2" },
      { label: "Col 3", value: "col3" },
    ],
    sheet: [
      { col1: "c11", col2: "c12", col3: "c13" },
      { col1: "c21", col2: "c22", col3: "c23" },
      { col1: "c31", col2: "c32", col3: "c33" },
    ],
  },
];
*/
const cookie = JSON.parse(localStorage.getItem(conf.cookieName));

export default function Excel() {
  const [data, setData] = useState();
  useEffect(() => {
    let data = {};
    if (cookie && cookie.excel) {
      data = cookie.excel;
      setData(data);
    }
  }, []);

  return (
    <div>
      {data && data[0] && (
        <ExcelFile hideElement={true}>
          {data.map((sheet, key) => (
            <ExcelSheet key={key} data={sheet.sheet} name={sheet.name}>
              {sheet.columns.map((col, key) => (
                <ExcelColumn label={col.label} key={key} value={col.value} />
              ))}
            </ExcelSheet>
          ))}
        </ExcelFile>
      )}
    </div>
  );
}
